import { translations } from "../../Translation/staticTranslation"
import {
  formatFeatureLabel,
  formatOrganizationMemberQuota,
  getOrganizationMemberFurnitureFinderStats,
  normalizeFeatureKey,
} from "../../organizationApiHelpers"

const getTableTranslations = (lang = "ar") =>
  translations[lang]?.organizationPage?.table || {}

const baseColumns = (t) => [
  {
    label: t?.email || "Email",
    dataKey: "email",
    cellClass: "org-cell-email",
    width: "18%",
  },
  {
    label: t?.status || "Status",
    dataKey: "org_member_status",
    width: "8%",
  },
  {
    label: t?.assigned || "Assigned",
    dataKey: "assigned_images",
    cellClass: "org-cell-num",
    width: "7%",
  },
  {
    label: t?.remaining || "Remaining",
    dataKey: "remaining_images",
    cellClass: "org-cell-num",
    width: "7%",
  },
  {
    label: t?.used || "Used",
    dataKey: "used_images",
    cellClass: "org-cell-num",
    width: "6%",
  },
  {
    label: t?.pending || "Pending",
    dataKey: "pending_allocation_images",
    cellClass: "org-cell-num",
    width: "6%",
  },
]

const furnitureFinderColumns = (t) => [
  {
    label: t?.ffRemaining || "FF balance",
    dataKey: "remaining_furniture_finder",
    cellClass: "org-cell-num",
    width: "8%",
  },
  {
    label: t?.ffPending || "FF pending",
    dataKey: "pending_allocation_furniture_finder",
    cellClass: "org-cell-num",
    width: "7%",
  },
]

const featuresColumn = (t) => ({
  label: t?.features || "Features",
  dataKey: "features_display",
  cellClass: "org-cell-features",
  width: "20%",
})

export function getOrganizationMemberColumns(lang = "ar", includeFurnitureFinder = false) {
  const t = getTableTranslations(lang)
  const columns = [...baseColumns(t)]
  if (includeFurnitureFinder) {
    columns.push(...furnitureFinderColumns(t))
  }
  columns.push(featuresColumn(t))
  return columns
}

const lang = localStorage.getItem("language") || "ar"
export const organizationMemberColumns = getOrganizationMemberColumns(lang, false)

export function mapMemberForTable(member, lang = "ar") {
  const statusLabels = translations[lang]?.organizationPage?.statusLabels || {}
  const status = String(member?.status || "").toLowerCase()
  const features = (
    Array.isArray(member?.allowed_features) ? member.allowed_features : []
  ).filter((f) => normalizeFeatureKey(f) !== "furniture_finder")

  const statusClass =
    status === "active"
      ? "active"
      : status === "invited"
        ? "pending"
        : status === "suspended"
          ? "rejected"
          : ""

  const furnitureFinder = getOrganizationMemberFurnitureFinderStats(member)

  return {
    ...member,
    org_member_status: statusLabels[status] || member?.status || "—",
    _orgStatusClass: statusClass,
    features_display:
      features.length > 0
        ? features.map((f) => formatFeatureLabel(f, lang)).join(", ")
        : "—",
    feature_tags: features.map((f) => formatFeatureLabel(f, lang)),
    remaining_furniture_finder: formatOrganizationMemberQuota(
      furnitureFinder.remaining,
    ),
    pending_allocation_furniture_finder: furnitureFinder.pending,
  }
}
